import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GlobalFaStylePipe } from './pipes/global-fa-style.pipe';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StringToObjectPipe } from './pipes/string-to-object.pipe';

@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule
  ],
  declarations: [
    GlobalFaStylePipe,
    StringToObjectPipe,
  ],
  exports: [
    StringToObjectPipe,
    GlobalFaStylePipe,
    FontAwesomeModule
  ]
})
export class SharedUiThemingModule {

}
